module.exports = __webpack_public_path__ + "static/003-0e8b7b740948b2143313a380cb5130e0.jpg";